import React from 'react';
import { getCardIcon } from '../../../../assets/constants/strings';
import CardOptions from './CardOptions';

const Card = ({ card, index, isDefault, handleOption }) => {
  return (
    <div className="card payment-card">
      <div className="card-header">
        <div className="d-flex align-items-center">
          <div className="payment-card__info">
            {/* image */}
            <img alt={card.brand} src={getCardIcon(card.brand)} />
            <div className="payment-card__info__col">
              <div className="d-flex">
                <b>****{card.last4}</b>
                {isDefault && (
                  <span className="default-badge">Default</span>
                )}
              </div>
              <span id="card-expires">{`Expires ${card.expMonth}/${card.expYear}`}</span>
            </div>
          </div>
        </div>
        <CardOptions index={index} isDefault={isDefault} handleOption={(value) => handleOption(value, card)} />
      </div>
    </div>
  );
};

export default Card;
